/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Ambienttemperaturesetpoint2Inputs */



/**
* | output |
* | --- |
* | "Ambient setpoint" |
*
* @param {Ahu_History_Key_Ambienttemperaturesetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_ambienttemperaturesetpoint2 = /** @type {((inputs?: Ahu_History_Key_Ambienttemperaturesetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Ambienttemperaturesetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient setpoint")
	return /** @type {LocalizedString} */ ("Consigne d'ambiance")
});
export { ahu_history_key_ambienttemperaturesetpoint2 as "ahu_history_key_ambientTemperatureSetpoint" }